import {
  ESalesViewActions,
  SalesViewActions,
} from '@myStore/sales-view/sales-view.actions';

import {
  initialsSalesViewState,
  ISalesViewState,
} from '@myStore/sales-view/sales-view.state';

export const salesViewReducers = (
  state = initialsSalesViewState,
  actions: SalesViewActions
): ISalesViewState => {
  switch (actions.type) {
    case ESalesViewActions.GetTokenForLeadFormRequest:
      return {
        ...state,
        leadForm: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetTokenForLeadFormSuccess:
      return {
        ...state,
        leadForm: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetTokenForLeadFormFailure:
      return {
        ...state,
        errors: actions.errors,
        leadForm: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetTokenForLeadFormErrors:
      return {
        ...state,
        errors: null,
        leadForm: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetPresentationInfoRequest:
      return {
        ...state,
        presentation: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetPresentationInfoSuccess:
      return {
        ...state,
        presentation: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetPresentationInfoFailure:
      return {
        ...state,
        errors: actions.errors,
        presentation: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetPresentationInfo:
      return {
        ...state,
        errors: null,
        presentation: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetEnrolleesRequest:
      return {
        ...state,
        enrollees: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetEnrolleesSuccess:
      return {
        ...state,
        enrollees: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetEnrolleesFailure:
      return {
        ...state,
        errors: actions.errors,
        enrollees: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetEnrollees:
      return {
        ...state,
        errors: null,
        enrollees: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetEnrolleesInPresentationRequest:
      return {
        ...state,
        enrolleesInPresentation: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetEnrolleesInPresentationSuccess:
      return {
        ...state,
        enrolleesInPresentation: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetEnrolleesInPresentationFailure:
      return {
        ...state,
        errors: actions.errors,
        enrolleesInPresentation: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetEnrolleesInPresentation:
      return {
        ...state,
        errors: null,
        enrolleesInPresentation: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetLeadsRequest:
      return {
        ...state,
        leads: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetLeadsSuccess:
      return {
        ...state,
        leads: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadsFailure:
      return {
        ...state,
        errors: actions.errors,
        leads: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetLeads:
      return {
        ...state,
        errors: null,
        leads: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetDealHistoryRequest:
      return {
        ...state,
        deal_history: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetDealHistorySuccess:
      return {
        ...state,
        deal_history: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetDealHistoryFailure:
      return {
        ...state,
        errors: actions.errors,
        deal_history: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetDealHistory:
      return {
        ...state,
        errors: null,
        deal_history: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetLeadRequest:
      return {
        ...state,
        lead: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetLeadSuccess:
      return {
        ...state,
        lead: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadFailure:
      return {
        ...state,
        errors: actions.errors,
        lead: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetLeadErrors:
      return {
        ...state,
        errors: null,
        lead: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetLeadStatusesRequest:
      return {
        ...state,
        leadStatuses: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetLeadStatusesSuccess:
      return {
        ...state,
        leadStatuses: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadStatusesFailure:
      return {
        ...state,
        errors: actions.errors,
        leadStatuses: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetLeadStatusesErrors:
      return {
        ...state,
        errors: null,
        leadStatuses: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetTasksRequest:
      return {
        ...state,
        tasks: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetTasksSuccess:
      return {
        ...state,
        tasks: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetTasksFailure:
      return {
        ...state,
        errors: actions.errors,
        tasks: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetTasksErrors:
      return {
        ...state,
        errors: null,
        tasks: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetTaskRequest:
      return {
        ...state,
        task: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetTaskSuccess:
      return {
        ...state,
        task: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetTaskFailure:
      return {
        ...state,
        errors: actions.errors,
        task: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetTaskErrors:
      return {
        ...state,
        errors: null,
        task: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetTaskFilesRequest:
      return {
        ...state,
        errors: null,
        taskFiles: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetTaskFilesSuccess:
      return {
        ...state,
        errors: null,
        taskFiles: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetTaskFilesFailure:
      return {
        ...state,
        errors: actions.errors,
        taskFiles: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetTaskFilesErrors:
      return {
        ...state,
        errors: null,
        taskFiles: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetContractCredentialsRequest:
      return {
        ...state,
        errors: null,
        contractCredentials: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetContractCredentialsSuccess:
      return {
        ...state,
        errors: null,
        contractCredentials: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetContractCredentialsFailure:
      return {
        ...state,
        errors: actions.errors,
        contractCredentials: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetContractCredentialsErrors:
      return {
        ...state,
        errors: null,
        contractCredentials: {
          data: null,
          isLoading: false,
        },
      };

    case ESalesViewActions.GetLeadDocumentsRequest:
      return {
        ...state,
        errors: null,
        lead_documents: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetLeadDocumentsSuccess:
      return {
        ...state,
        errors: null,
        lead_documents: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadDocumentsFailure:
      return {
        ...state,
        errors: actions.errors,
        lead_documents: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetLeadDocumentsErrors:
      return {
        ...state,
        errors: null,
        lead_documents: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadContractRequest:
      return {
        ...state,
        lead_contract: {
          data: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetLeadContractSuccess:
      return {
        ...state,
        lead_contract: {
          data: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetLeadContractFailure:
      return {
        ...state,
        lead_contract: {
          data: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.GetAllSalesDealsRequest:
      return {
        ...state,
        deals: {
          data: null,
          oneDeal: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetAllSalesDealsSuccess:
      return {
        ...state,
        deals: {
          data: actions.data,
          oneDeal: null,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetAllSalesDealsFailure:
      return {
        ...state,
        deals: {
          data: null,
          oneDeal: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.GetOneDealByIDRequest:
      return {
        ...state,
        deals: {
          ...state.deals,
          oneDeal: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetOneDealByIDSuccess:
      return {
        ...state,
        deals: {
          ...state.deals,
          oneDeal: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetOneDealByIDFailure:
      return {
        ...state,
        deals: {
          ...state.deals,
          oneDeal: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.ClearGetOneDealByIDErrors:
      return {
        ...state,
        deals: {
          ...state.deals,
          oneDeal: null,
          isLoading: false,
        },
        errors: null,
      };

    case ESalesViewActions.GetAllPaymentsRequest:
      return {
        ...state,
        payments: {
          ...state.payments,
          data: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetAllPaymentsSuccess:
      return {
        ...state,
        payments: {
          ...state.payments,
          data: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetAllPaymentsFailure:
      return {
        ...state,
        payments: {
          ...state.payments,
          data: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.ClearGetAllPaymentsErrors:
      return {
        ...state,
        payments: {
          ...state.payments,
          data: null,
          isLoading: false,
        },
        errors: null,
      };

    case ESalesViewActions.GetFullViewOfPaymentRequest:
      return {
        ...state,
        payments_full_view: {
          ...state.payments,
          data: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetFullViewOfPaymentSuccess:
      return {
        ...state,
        payments_full_view: {
          ...state.payments,
          data: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetFullViewOfPaymentFailure:
      return {
        ...state,
        payments_full_view: {
          ...state.payments,
          data: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.ClearGetFullViewOfPaymentErrors:
      return {
        ...state,
        payments_full_view: {
          data: null,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetAllDiscountsRequest:
      return {
        ...state,
        discounts: {
          ...state.payments,
          data: null,
          isLoading: true,
        },
        errors: null,
      };

    case ESalesViewActions.GetAllDiscountsSuccess:
      return {
        ...state,
        discounts: {
          ...state.payments,
          data: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetAllDiscountsFailure:
      return {
        ...state,
        discounts: {
          ...state.payments,
          data: null,
          isLoading: false,
        },
        errors: actions.errors,
      };
    case ESalesViewActions.GetApplicantsRequest:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          data: null,
          isLoading: true,
        },
        errors: null,
      };
    case ESalesViewActions.GetApplicantsSuccess:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          data: actions.data,
          isLoading: false,
        },
        errors: null,
      };
    case ESalesViewActions.GetApplicantsFailure:
      return {
        ...state,
        applicants: {
          ...state.applicants,
          data: null,
          isLoading: false,
        },
        errors: actions.errors,
      };

    case ESalesViewActions.GetLeadInQRRequest:
      return {
        ...state,
        errors: null,
        lead_by_qr: {
          data: null,
          isLoading: true,
        },
      };
    case ESalesViewActions.GetLeadInQRSuccess:
      return {
        ...state,
        errors: null,
        lead_by_qr: {
          data: actions.data,
          isLoading: false,
        },
      };
    case ESalesViewActions.GetLeadInQRFailure:
      return {
        ...state,
        errors: actions.errors,
        lead_by_qr: {
          data: null,
          isLoading: false,
        },
      };
    case ESalesViewActions.ClearGetLeadInQR:
      return {
        ...state,
        errors: null,
        lead_by_qr: {
          data: null,
          isLoading: false,
        },
      };
  }
  return state;
};
